// src/error.ts
var createError = (data) => {
  return Object.assign(
    (extension = {}) => createError({
      ...data,
      ...extension
    }),
    {
      __typename: "error",
      data,
      toResponse: () => ({ __typename: "error", ok: false, ...data })
    }
  );
};
var ServiceError = class _ServiceError extends Error {
  constructor(error) {
    super(error.data.message);
    this.error = error;
  }
  __typename = "ServiceError";
  get data() {
    return this.error.data;
  }
  toResponse() {
    return this.error.toResponse();
  }
  static fromResponse(raw) {
    let data = raw;
    delete data.ok;
    delete data.__typename;
    return new _ServiceError(createError(data));
  }
};
var isError = (e) => {
  return (e == null ? void 0 : e.__typename) === "ServiceError" || (e == null ? void 0 : e.__typename) === "ErrorRecord";
};
var isServiceError = isError;

// src/defaultErrors.ts
var validationError = (d) => createError({
  status: 400,
  code: "invalid_data",
  message: "The provided data is invalid.",
  hint: "Make sure the data you are sending follows the specification outlined in the documentation.",
  ...d
});
var internalServerError = createError({
  status: 500,
  code: "internal_server_error",
  message: "An internal server error occurred.",
  hint: `This error means that something went wrong on our end. Please try again later. If the problem persists please contact support.`
});
var badRequestError = createError({
  status: 400,
  code: "bad_request",
  message: "The request is invalid.",
  hint: "Make sure the request you are sending follows the specification outlined in the documentation."
});
var notFoundError = (d) => createError({
  status: 404,
  code: "not_found",
  message: `The requested ${d.entity.replaceAll("_", " ").replaceAll(".", " ")} could not be found.`,
  hint: "Make sure the resource you are trying to access exists and that you have access to it.",
  ...d
});
var unauthorizedError = createError({
  status: 401,
  code: "unauthorized",
  message: "You are not authorized to access this resource.",
  hint: "Make sure you are logged in and have the correct permissions to access this resource."
});
var forbiddenError = createError({
  status: 403,
  code: "forbidden",
  message: "You do not have permission to access this resource.",
  hint: `Only clients with the correct permissions can access this resource.`
});
var invalidVersion = createError({
  status: 400,
  code: "invalid_version",
  message: "The requested version does not exist.",
  hint: `This endpoint does not have a version with the id you provided. You can leave the version header empty to use the latest version.`
});
var conflictError = createError({
  status: 409,
  code: "conflict",
  message: "A similar resource already exists.",
  hint: `You might be trying to create a resource with a key that already exists.`
});
var goneError = createError({
  status: 410,
  code: "gone",
  message: "The requested resource is no longer available.",
  hint: `This resource is no longer available.`
});
var unsupportedMediaTypeError = createError({
  status: 415,
  code: "unsupported_media_type",
  message: "The media type of the request is not supported.",
  hint: `The media type of the request is not supported.`
});
var tooManyRequestsError = createError({
  status: 429,
  code: "too_many_requests",
  message: "You have sent too many requests.",
  hint: `You have sent too many requests in a given amount of time.`
});
var serviceUnavailableError = createError({
  status: 503,
  code: "service_unavailable",
  message: "The service is temporarily unavailable."
});
var notImplementedError = createError({
  status: 501,
  code: "not_implemented",
  message: "The requested feature is not implemented."
});
var paymentRequiredError = createError({
  status: 402,
  code: "payment_required",
  message: "Payment is required to access this resource."
});
var preconditionFailedError = createError({
  status: 412,
  code: "precondition_failed",
  message: "The precondition of the request failed."
});
var lengthRequiredError = createError({
  status: 411,
  code: "length_required",
  message: "The length of the request is required."
});
var requestEntityTooLargeError = createError({
  status: 413,
  code: "request_entity_too_large",
  message: "The request entity is too large."
});
var notAcceptableError = createError({
  status: 406,
  code: "not_acceptable",
  message: "The requested media type is not acceptable."
});
export {
  ServiceError,
  badRequestError,
  conflictError,
  createError,
  forbiddenError,
  goneError,
  internalServerError,
  invalidVersion,
  isError,
  isServiceError,
  lengthRequiredError,
  notAcceptableError,
  notFoundError,
  notImplementedError,
  paymentRequiredError,
  preconditionFailedError,
  requestEntityTooLargeError,
  serviceUnavailableError,
  tooManyRequestsError,
  unauthorizedError,
  unsupportedMediaTypeError,
  validationError
};
//# sourceMappingURL=index.mjs.map